function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.333 4.333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.71 11.178l4.31 4.329c.418.416.418 1.097 0 1.514-.416.416-1.097.416-1.514 0l-4.321-4.319V11.9l-.275-.285c-1.423 1.22-3.365 1.85-5.43 1.504C2.655 12.64.398 10.284.052 7.439-.477 3.14 3.142-.477 7.443.05c2.847.346 5.206 2.602 5.684 5.427.345 2.062-.285 4.003-1.505 5.426l.285.274h.803zm-6.1 0c2.531 0 4.575-2.042 4.575-4.572 0-2.53-2.044-4.573-4.576-4.573-2.531 0-4.575 2.042-4.575 4.573 0 2.53 2.044 4.572 4.575 4.572z"
}));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#b8c8cc",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.c11bacc0.svg";
export { ForwardRef as ReactComponent };